module.exports = "#noDevicesMessage {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-devices/no-devices.component.scss
// module id = ./src/app/shared/components/no-devices/no-devices.component.scss
// module chunks = main